import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { TableHeader } from "@/types/table-header";
import { Table } from "flowbite-react";
import { Body14Regular } from "../../typography/Body14Regular";
import { CustomCell } from "../CustomCell";
import { PackageItemChildSelectTableRow } from "./PackageItemChildSelectTableRow";

interface Props {
  items: ItemDetailDto[];
  removeItem: (id: number) => void;
}

const headers: TableHeader[] = [
  { title: "상품명", width: "w-[308px]" },
  { title: "판매 여부", width: "w-[100px]" },
  { title: "진열 여부", width: "w-[100px]" },
  { title: "삭제", width: "w-[56px]" },
];
export const PackageItemChildSelectedTable: React.FC<Props> = ({
  items,
  removeItem,
}) => {
  return (
    <div className="overflow-x-auto rounded-lg border h-[320px]">
      <Table>
        <Table.Head>
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px] p-0 border-b"}
            >
              <div className={header.align}>
                <CustomCell>
                  <Footnote12Description
                    className={"text-semantic-text-secondary"}
                  >
                    {header.title}
                  </Footnote12Description>
                </CustomCell>
              </div>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {items.map((item, index) => (
            <PackageItemChildSelectTableRow
              key={item.id}
              item={item}
              removeItem={removeItem}
            />
          ))}
          {items.length === 0 && (
            <Table.Row>
              <Table.Cell colSpan={Object.values(headers).length}>
                <div className="flex justify-center items-center h-[268px]">
                  <Body14Regular className="text-semantic-text-tertiary">
                    결합할 상품을 좌측 리스트에서 담아주세요
                  </Body14Regular>
                </div>
              </Table.Cell>
            </Table.Row>
          )}
          {/* <PackageItemChildSelectTableFooter
            headersLength={Object.values(headers).length}
            itemPage={itemPage}
            handlePageChange={handlePageChange}
          /> */}
        </Table.Body>
      </Table>
    </div>
  );
};
